import React, { HTMLProps } from "react";
import { ChangeHandler, FieldError } from "react-hook-form";
import classNames from "classnames";

interface Props extends HTMLProps<HTMLInputElement> {
  onChange?: ChangeHandler;
  onBlur?: ChangeHandler;
  name?: string;
  value?: string | number | undefined;
  placeholder?: string;
  className?: string;
  type?: string;
  icon?: string;
  onIconClick?(): void;
  error?: FieldError;
  inputClassName?: string;
  labelClassName?: string;
  fileClassName?: string;
  iconClassName?: string;
  isfile?: boolean;
  disabled?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    onChange,
    onBlur,
    name,
    label,
    placeholder,
    className,
    icon,
    error,
    type,
    inputClassName,
    labelClassName,
    fileClassName,
    iconClassName,
    onIconClick,
    required,
    isfile,
    disabled = false,
    ...rest
  } = props;
  return (
    <label
      className={`flex flex-col relative items-stretch label ${disabled ? "pointer-events-none" : ""} ${className}`}
    >
      <div className={`mb-1 ${labelClassName}`}>
        {isfile && <span className={`text-xl font-medium text-black cursor-pointer ${fileClassName}`}>+</span>}
        <span>
          {label}
          {required ? "*" : ""}
        </span>
      </div>
      <div className="relative group">
        <input
          name={name}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          type={type || "text"}
          placeholder={placeholder}
          className={` w-full input input-bordered ${error && "input-error"} ${inputClassName} ${
            disabled ? "bg-pkc-gray-light text-pkc-greyish-brown border-pkc-secondary " : ""
          }`}
          {...rest}
        />

        {icon && (
          <i
            className={classNames(
              `absolute left-5 h-12 w-4 bottom-0 text-pkc-form-icon flex items-center pl-2 pr-2 ${icon}`,
              iconClassName
            )}
            onClick={onIconClick}
          />
        )}
      </div>
      {error && <p className="mt-1 text-pkc-red">{error.message}</p>}
    </label>
  );
});

export default Input;
